import getYouTubeUrlRegex from './getYouTubeUrlRegex';

export default ({ url }) => {
  // The regular expression to match YouTube URLs with /watch?v= or youtu.be/ formats
  const regex = getYouTubeUrlRegex();

  // Match the given URL against the regular expression
  const match = url.match(regex);

  // If a match is found, construct the embed URL using the video ID (match[1])
  if (match) return `https://www.youtube.com/embed/${match[1]}`;

  // If no match is found, return the original URL
  return url;
};
